<template>
  <list-table
    :url="url"
    title="لیست درگاه ها"
    :detailUrl="detailUrl"
    :viewUrl="viewUrl"
    :fields="fields"
    :params="params"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import TableShowData from "../../components/table";
export default {
  name: "Merchants",
  props: ["apiParams"],
  data() {
    return {
      url: this.apiParams
        ? `paymentgateways?mdid12_money_type=${this.apiParams}`
        : "paymentgateways?mdid12_money_type=483",
      fields: [
        {
          key: "id",
          label: "کد",
        },
        {
          key: "user.name",
          label: "نام مالک درگاه",
          formatter(value, key, item) {
            return item.user.fa_name + " " + item.user.fa_family;
          },
        },
        {
          key: "acceptor_code",
          label: "کد پذیرنده",
        },
        {
          key: "website_name",
          label: "نام وبسایت",
        },
        {
          key: "website_en_name",
          label: "نام انگلیسی",
        },
        {
          key: "website",
          label: "آدرس",
          tdClass: 'my-class',
        },
        this.apiParams !== "1722"
          ? {
              key: "is_direct",
              label: "نوع درگاه",
              formatter: (value, key, item) => {
                return value ? "مستقیم" : "واسط";
              },
              tdClass: "text-primary",
            }
          : {},
        // {
        //   key: "statusName",
        //   label: "وضعیت",
        //   formatter: (value, key, item) => {
        //     console.log(value);
        //     return value;
        //   },
        //   tdClass: (value, key, item) => {
        //     return item.mdid19_status != 1580 ? "text-success" : "text-danger";
        //   },
        // },
        {
          key: "mdid117_description.title",
          label: "توضیحات",
        },
        {
          key: "money_type.title",
          label: "واحد پولی",
        },
        // {
        //   key: "user.confirmallstatus",
        //   label: "وضعیت احراز هویت",
        //   formatter: (value, key, item) => {
        //     return value == true ? "احراز شده" : "احراز نشده";
        //   },
        // },
        {
          key: "details",
          label: "جزییات",
        },
      ],
      params: [
        {
          label: "نام وبسایت",
          field: "website_name",
          type: "text",
        },
        {
          label: "نام انگلیسی وبسایت",
          field: "website_en_name",
          type: "text",
        },
        {
          label: "آدرس وبسایت",
          field: "website",
          type: "text",
        },
        {
          label: "کد پذیرنده",
          field: "acceptor_code",
          type: "text",
        },
        {
          label: "نام مالک درگاه",
          field: "name",
          type: "text",
        },
        {
          label: "وضعیت",
          field: "mdid19_status",
          type: "mddropdown",
          group: 19,
        },
      ],
      detailUrl: "editGateway",
      viewUrl: "viewGateway",
    };
  },
  components: {
    "list-table": TableShowData,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست درگاه های ریالی",
      },
    ]);
    this.apiParams != "1722"
      ? this.params.push(
          {
            label: "نوع درگاه",
            field: "is_direct",
            type: "select",
            value: null,
            options: [
              { text: "همه ی موارد", value: null },
              { text: "مستقیم", value: "1" },
              { text: "واسط", value: "0" },
            ],
          },
          {
            label: "کد درگاه",
            field: "payment_gateway_id",
            type: "text",
          },
          {
            label: "توضیحات",
            field: "mdid117_description",
            type: "mddropdown",
            group: 117,
          }
        )
      : this.params.push({
          label: "توضیحات",
          field: "mdid117_description",
          type: "mddropdown",
          group: 118,
        });
  },
};
</script>
<style >
.my-class { 
  display: inline-block;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      max-width: 30ch;
                      direction: ltr;
 }
</style>
